import { useContext as commonUseContext } from "packages/react";

export const useContext = commonUseContext;
